module.exports = "<svg viewBox=\"0 0 33 14\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#9A9A9A\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M16.5 7S30.888-4.184 30.888 7 16.5 7 16.5 7zM16.5 7S2.112-4.184 2.112 7 16.5 7 16.5 7z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/campaign/NewCampaign/SegmentOptionRow/dynamic-icon.svg
// module id = bZrC
// module chunks = 89